import { ProductBlocksDownload_link } from "_types";
import { ReactProductState } from "product";
import { FC } from "react";
import { StoreApi, UseBoundStore } from "zustand";

export const ProductLeadTime: FC<{
  settings: ProductBlocksDownload_link["settings"];
  useProduct: UseBoundStore<StoreApi<ReactProductState>>;
}> = ({ settings, useProduct }) => {
  const { product, selectedVariant, quantity } = useProduct(
    ({ product, selectedVariant, quantity }) => ({
      product,
      selectedVariant,
      quantity,
    })
  );

  const shouldShowLeadTime =
    quantity > selectedVariant?.inventory_quantity ||
    selectedVariant?.inventory_quantity < 1 ||
    settings.lead_time_threshold === "always_show";

  return (
    <div className="grid grid-cols-12 lg:grid-cols-3">
      {
        <>
          {shouldShowLeadTime ? (
            <>
              <div className="col-span-8 lg:col-span-5">
                <p className="mt-[2px]">
                  {product?.metafields?.bathroomspace.lead_time ? settings?.text : ""}{" "}
                  {product?.metafields?.bathroomspace.lead_time}
                </p>
                <p className="text-xs text-gray-500">
                  {product?.metafields?.bathroomspace.lead_time_sublabel
                    ? (product?.metafields?.bathroomspace.lead_time_sublabel as string)
                    : ""}
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="col-span-8 lg:col-span-3">
                <p className="mt-[2px]">In Stock</p>
              </div>
            </>
          )}
          {product?.metafields?.bathroomspace.specifications_pdf_url ? (
            <>
              <div className="col-span-4 flex justify-end lg:col-span-1 lg:justify-start lg:pt-2">
                <a
                  href={
                    (product?.metafields?.bathroomspace.specifications_pdf_url as string) || "#"
                  }
                  className="flex items-center text-[#00326f]"
                  target="_blank"
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.7217 16.8415C10.7244 16.8415 12.3531 15.2118 12.3531 13.2102C12.3531 11.2086 10.7245 9.5788 8.7217 9.5788C6.71905 9.5788 5.09033 11.2085 5.09033 13.2102C5.09033 15.2117 6.71893 16.8415 8.7217 16.8415ZM8.7217 10.4543C10.242 10.4543 11.4778 11.6902 11.4778 13.2104C11.4778 14.7306 10.2419 15.9665 8.7217 15.9665C7.20151 15.9665 5.96557 14.7306 5.96557 13.2104C5.96557 11.6902 7.20151 10.4543 8.7217 10.4543Z"
                      fill="#00326F"
                    />
                    <path
                      d="M25.2279 16.1264H14.3987C14.8504 15.2514 15.1096 14.2615 15.1096 13.2104C15.1096 12.4557 14.9718 11.7338 14.7301 11.0612L15.1829 10.6138C15.2999 10.4979 15.3415 10.3273 15.2922 10.1698L14.2663 6.94232C14.2302 6.82857 14.1482 6.73451 14.041 6.68201C13.9338 6.62952 13.8102 6.62295 13.6975 6.66451L11.5122 7.47171C10.6679 7.05936 9.72395 6.82201 8.7232 6.82201C5.20127 6.82201 2.33594 9.68758 2.33594 13.2093V19.1593C2.33594 19.401 2.53172 19.5968 2.77344 19.5968L23.3609 19.5979V20.4882C23.3609 20.9705 23.7536 21.3632 24.2359 21.3632H24.7893C25.2717 21.3632 25.6643 20.9705 25.6643 20.4882V16.5637C25.6643 16.322 25.4686 16.1262 25.2268 16.1262L25.2279 16.1264ZM13.5696 7.64423L14.3757 10.1796L14.3538 10.2015C13.8967 9.34947 13.2492 8.61666 12.4715 8.0501L13.5696 7.64423ZM8.72236 7.69783C11.7618 7.69783 14.2351 10.1707 14.2351 13.2106C14.2351 16.2511 11.7622 18.7233 8.72236 18.7233H5.58542V17.9752C5.58542 16.9558 4.75637 16.1256 3.73588 16.1256H3.20979V13.2097C3.20979 10.1703 5.68265 7.69694 8.72252 7.69694L8.72236 7.69783ZM3.20892 17.0013H3.73502C4.27206 17.0013 4.70956 17.4388 4.70956 17.9758V18.7239H3.20895L3.20892 17.0013ZM11.9326 18.7229C12.6829 18.2832 13.3348 17.6969 13.851 17.0013H15.3188V17.8621C15.3188 18.1038 15.5146 18.2996 15.7563 18.2996C15.998 18.2996 16.1938 18.1038 16.1938 17.8621V17.0013H18.1429V17.8621C18.1429 18.1038 18.3386 18.2996 18.5804 18.2996C18.8221 18.2996 19.0179 18.1038 19.0179 17.8621V17.0013H20.9669V17.8621C20.9669 18.1038 21.1627 18.2996 21.4044 18.2996C21.6461 18.2996 21.8419 18.1038 21.8419 17.8621V17.0013H23.3622V18.7229H11.9326ZM24.236 20.4882V17.0012H24.7894V20.4882H24.236Z"
                      fill="#00326F"
                    />
                  </svg>
                  {settings?.heading}
                </a>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      }
    </div>
  );
};
